import type { AnalyticsConfig } from './config';

declare global {
  interface Window {
    dataLayer?: unknown[][];
  }
}

function appendScript(id: string, source: string): void {
  if (document.getElementById(id)) return;
  const script = document.createElement('script');
  script.async = true;
  script.id = id;
  script.src = source;
  document.head.append(script);
}

export function loadAnalyticsProvider(config: AnalyticsConfig): void {
  if (!config.enabled || !config.market || !config.measurementId) return;
  if (config.market === 'ru') {
    const counterId = Number(config.measurementId);
    if (!Number.isSafeInteger(counterId)) return;
    if (!window.ym) {
      const queue: unknown[][] = [];
      const queued = Object.assign(
        (...args: unknown[]) => {
          queue.push(args);
        },
        { a: queue, l: Date.now() }
      );
      window.ym = queued;
    }
    appendScript('rw-yandex-metrika', 'https://mc.yandex.ru/metrika/tag.js');
    window.ym(counterId, 'init', {
      accurateTrackBounce: true,
      clickmap: true,
      trackLinks: true,
      webvisor: false,
    });
    return;
  }

  window.dataLayer ??= [];
  window.gtag ??= (...args: unknown[]) => window.dataLayer?.push(args);
  appendScript(
    'rw-google-analytics',
    `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.measurementId)}`
  );
  window.gtag('js', new Date());
  window.gtag('config', config.measurementId, { anonymize_ip: true, send_page_view: false });
}
